import { EnumTranslationPipe } from './enum-translation.pipe';
import { CustomFieldCompositionDto } from '@artemis-software/wr-api';
import { Pipe, PipeTransform } from '@angular/core';

const LABELS: Record<CustomFieldCompositionDto.ValueTypeEnum, string> = {
  String: 'Kurzer Text',
  Longtext: 'Langer Text',
  LongtextWithPresets: 'Langer Text mit Vorschlägen',
  Integer: 'Ganze Zahl',
  Double: 'Dezimalzahl',
  Boolean: 'Ja/Nein',
  MultipleChoice: 'Mehrfachauswahl',
  LocalDate: 'Datum',
  LocalDateTime: 'Datum & Uhrzeit',
  Attachment: 'Anhang',
  Table: 'Tabelle',
  Signature: 'Unterschrift',
};

@Pipe({
  standalone: false,
  name: 'valueTypeTranslation',
})
export class ValueTypeTranslationPipe implements EnumTranslationPipe<CustomFieldCompositionDto.ValueTypeEnum | null | undefined>, PipeTransform {
  transform(value: CustomFieldCompositionDto.ValueTypeEnum | null | undefined): string {
    if (!value) {
      return '–';
    }
    const label = LABELS[value];
    if (!label) {
      console.error(`Unknown value type: ${value}`);
      return '–';
    }
    return label;
  }
}
